import React, { useState } from 'react'
import { VStack } from '@chakra-ui/react'
import { LetterContainer } from './LetterContainer'
import { WordFieldBox } from './WordFieldBox'
import type { Glossary } from '@/types/glossary'

type DektopProps = {
  availableLetters: string[]
  itemsDict: { [key: string]: Glossary[] }
  selectedLetter: string
  setSelectedLetter: (val: string) => void
}

export const Desktop = ({
  availableLetters,
  itemsDict,
  selectedLetter,
  setSelectedLetter,
}: DektopProps) => {
  const [selectedWord, setSelectedWord] = useState('')

  return (
    <>
      <LetterContainer
        availableLetters={availableLetters}
        selectedLetter={selectedLetter}
        setSelectedLetter={setSelectedLetter}
      />
      <VStack w={'100%'} my={8}>
        {availableLetters.map((letter, index) => {
          return (
            <VStack id={index === 0 ? '#' : letter} w={'100%'}>
              {itemsDict[letter].map(({ slug, title, acf }) => (
                <WordFieldBox
                  key={title}
                  slug={slug}
                  name={title}
                  shortDescription={acf.short_description}
                  selectedWord={selectedWord}
                  setSelectedWord={setSelectedWord}
                />
              ))}
            </VStack>
          )
        })}
      </VStack>
    </>
  )
}
